import React from "react";

import Faq from "../components/FAQ";
import Layout from "../components/Layout";

const FAQPage = () => {
	return (
		<Layout>
				<Faq />
		</Layout>
	);
};

export default FAQPage;
